import SkillDisplayWithCategories from './SkillDisplayWithCategories.jsx';

export default SkillDisplayWithCategories;
